<template>
	<div>

		<main>
			<PageView />
		</main>
	</div>
</template>

<script>
	export default {
		name: 'user-dashboard',

		components: {
			PageView: () => import('./core/PageView')
		}
	}
</script>

<style lang="scss">

</style>